import React from 'react';
import * as Icons from './Icons';

export enum IconNames {
  Person = 'Person',
  People = 'People',
  Power = 'Power',
  Check = 'Check',
  CheckCircle = 'CheckCircle',
  CheckSquare = 'CheckSquare',
  SmartRecord = 'SmartRecord',
  BlockSmartRecord = 'BlockSmartRecord',
  Replay = 'Replay',
  Clear = 'Clear',
  CloseEye = 'CloseEye',
  OpenEye = 'OpenEye',
  ArrowRight = 'ArrowRight',
  NoAvailable = 'NoAvailable',
  BallBackground = 'BallBackground',
  BallBlue = 'BallBlue',
  BallRed = 'BallRed',
  BallGold = 'BallGold',
  BallUndefined = 'BallUndefined',
  Warning = 'Warning',
  LoadingIndicator = 'LoadingIndicator',
  NoAvailablePage = 'NoAvailablePage',
  Add = 'Add',
  Remove = 'Remove',
  Search = 'Search',
  Triangle = 'Triangle',

  UndefinedCard = 'UndefinedCard',
  clubs = 'clubs',
  hearts = 'hearts',
  spades = 'spades',
  diamonds = 'diamonds',

  red_rank_ace = 'red_rank_ace',
  red_rank_2 = 'red_rank_2',
  red_rank_3 = 'red_rank_3',
  red_rank_4 = 'red_rank_4',
  red_rank_5 = 'red_rank_5',
  red_rank_6 = 'red_rank_6',
  red_rank_7 = 'red_rank_7',
  red_rank_8 = 'red_rank_8',
  red_rank_9 = 'red_rank_9',
  red_rank_10 = 'red_rank_10',
  red_rank_jack = 'red_rank_jack',
  red_rank_queen = 'red_rank_queen',
  red_rank_king = 'red_rank_king',

  black_rank_ace = 'black_rank_ace',
  black_rank_2 = 'black_rank_2',
  black_rank_3 = 'black_rank_3',
  black_rank_4 = 'black_rank_4',
  black_rank_5 = 'black_rank_5',
  black_rank_6 = 'black_rank_6',
  black_rank_7 = 'black_rank_7',
  black_rank_8 = 'black_rank_8',
  black_rank_9 = 'black_rank_9',
  black_rank_10 = 'black_rank_10',
  black_rank_jack = 'black_rank_jack',
  black_rank_queen = 'black_rank_queen',
  black_rank_king = 'black_rank_king',

  Background = 'Background',
  Shuffle = 'Shuffle',
  Cancel = 'Cancel',
  Rescan = 'Rescan',
  Cards = 'Cards',
}

export interface IProps {
  name: IconNames;
  onClick?: () => void;
  className?: string;
}

const IconsMap: { [key: string]: any } = Icons;

export const Icon = ({ name, onClick, className }: IProps) => {
  const IconComponent = IconsMap[name];

  return <IconComponent onClick={onClick} className={className} />;
};
